<template>
  <b-overlay :show="isLoading" rounded="lg">
    <b-card title="Kiosk Warehouse">
      <b-modal v-model="modalConfirmation" :title="modalTitle">
        <!-- Alert before Delete PO-->
        <b-container>
          <b-row>
            <b-col cols="12" >
              <div class="d-flex">
                Are you sure want to {{ messageModal }} this {{selectPO.PONumber}} ?
              </div>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="danger" class="ml-1" @click="confirmEdit">Confirm</b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="modalLock" title="Stock check in progress" centered>
        <p class="text-center mb-0">{{ lockMessage }}</p>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center">
            <b-button variant="primary" @click="modalLock = false">OK</b-button>
          </div>
        </template>
      </b-modal>
      <b-modal v-model="modalInfo" title="Stock Check Complete" hide-header-close no-close-on-backdrop 
  no-close-on-esc  hide-footer centered>
        <div class="d-flex flex-column align-items-center">
          <p class="text-center">Please bring items for PO {{ modalInfoMessage }} to counter {{ modalCounterName }} to verify item type.</p>
          <div class="d-flex justify-content-center mt-2">
            <b-button variant="primary" @click="handleInfoClose">OK</b-button>
          </div>
        </div>
      </b-modal>

      <!-- End of Modal Needed on this page-->
      <b-col cols="12">
        <b-row>
          <b-col cols="4">
            <b-form-input
              class="mt-2"
              @input="(value) => doFiltering(value)"
              v-model="search"
              type="search"
              placeholder="Type to Search Order Number"
            />
          </b-col>
          <b-col cols="4">
            <strong>Updated Date</strong>
            <b-form-input
              v-model="filterDate"
              type="date"
              @input="onDateFilterChange"
            />
          </b-col>
          <b-col cols="4">
            <b-button
              class="mt-2 float-right"
              variant="primary"
              @click="refresfMethod()"
            >
              Refresh Kiosk PO
            </b-button>
          </b-col>
          <b-row>
            <b-col cols="4" class="mt-2">
            <strong>Status</strong>
            <b-form-select
              v-model="sapStatus"
              :options="statusOptions"
              @input="(value) => statusFiltering(value)"
            />
          </b-col>
          <b-col cols="4" class="mt-2">
            <strong>Check Stock Status</strong>
            <b-form-select
              v-model="checkStockStatus"
              :options="checkStockStatusOptions"
              @input="onCheckStockStatusChange"
            />
          </b-col>
          </b-row>
          
          
          <b-col style="margin: 15px 0 0 0" cols="12">
            <b-table
              class="custom-row-height"
              :busy.sync="tableLoading"
              show-empty
              :items="filteredPurchase"
              :fields="fields"
              thead-class="compact-header"
              tbody-class="compact-body"
              responsive
            >
              <template #cell(item)="row">
                <div v-for="(model, index) in row.item.item" :key="index" style="margin-bottom: 6px;">
                  {{ model }}
                </div>
              </template>

              <template #cell(qty)="row">
                <div v-for="(quantity, index) in row.item.qty" :key="index" style="margin-bottom: 6px;">
                  {{ quantity }}
                </div>
              </template>

              <template #cell(itemStatus)="row">
                <div v-for="(status, index) in row.item.status" :key="index" style="margin-bottom: 6px;">
                  {{ status == "Safe" ? 'Available' : (status == "Replacement Item Safe" ? "Replacement Available" : status) }}
                </div>
              </template>

              <template #cell(updatedAt)="row">
                {{ dates(row.item.updatedAt) }}
              </template>

              <template #cell(status)="row">
                {{ statusParser(row.item) }}
              </template>

              <template #cell(counterName)="row">
                {{ row.item.counterName || '-' }}
              </template>

              <template #cell(checkedBy)="row">
                {{ row.item.checkedBy || '-' }}
              </template>

              <template #cell(lastCheckedBy)="row">
                {{ row.item.lastCheckedBy || '-' }}
              </template>

              <template #cell(actions)="row">
                <div>
                  <b-button
                    v-if="showCheckStock(row.item) && !isClaimedByOther(row.item)"
                    size="sm"
                    @click="detailPO(row)"
                    variant="info"
                    class="mr-1"
                  >
                    Check Stock
                  </b-button>
                  <b-button
                    v-else-if="showCheckStock(row.item) && isClaimedByOther(row.item)"
                    size="sm"
                    variant="secondary"
                    disabled
                    class="mr-1"
                  >
                    Checking by {{ row.item.checkedBy }}
                  </b-button>
                  <b-button
                    v-if="isSuperAdmin && isClaimedByOther(row.item)"
                    size="sm"
                    variant="warning"
                    @click="confirmRelease(row)"
                  >
                    Release
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>

          <b-col cols="12">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              @change="onPageChange"
              v-model="currentPage"
              style="float: right"
            />
          </b-col>
        </b-row>
        
      </b-col>
      
    </b-card>
  </b-overlay>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex';
  import {userAccess,dateFormat} from '@/utils/utils'
  import lodash from 'lodash';
  import axios from '@/axios';
  
  export default {
    data() {
      return {
        fields: [
          { key: 'rspOrderNumber', label: 'Order Number', filterable: true, sortable: true },
          { key: 'status', label: 'Status', filterable: true, sortable: true, },
          { key: 'item', label: "Item Model", filterable: true, sortable: true},
          { key: 'qty', label: "QTY", filterable: true, sortable: true},
          { key: 'itemStatus', label: "Check Stock Status", filterable: true, sortable: true},
          { key: 'counterName', label: 'Counter', filterable: true, sortable: true },
          { key: 'checkedBy', label: 'Check by', filterable: true, sortable: true },
          { key: 'lastCheckedBy', label: 'Last checked by', filterable: true, sortable: true },
          { key: 'updatedAt', label:'Kiosk PO Updated Date', filterable: true, sortable: true},
          { key: 'actions', label: 'Actions' },
        ],
        search: '',
        currentPage: 1,
        perPage: 10,
        totalRows: 1,
        tableLoading: true,
        modalDelete: false,
        selectPO:'',
        sapStatus: 'Checking',
        filterDate: new Date().toISOString().slice(0, 10),
        checkStockStatus: 'Not Checked Yet',
        modalTitle: "",
        modalConfirmation: false,
        messageModal : "",
        intervalId: null,
        isPolling : false,
        modalInfo: false,
        modalInfoMessage: "",
        modalCounterName: "the counter",
        modalLock: false,
        lockMessage: "",
        isLoading: false,
        checkStockStatusOptions: [
          { value: 'Not Checked Yet', text: 'Not Checked Yet' },
          { value: 'Checking in progress', text: 'Checking in progress' },
          { value: 'ALL', text: 'All' },
        ],
        statusOptions: [
          { value: 'ALL', text: 'All' },
          { value: '', text: 'Created' },
          { value: 'Awaiting Discount Approval', text: 'Awaiting Discount Approval' },
          { value: 'Checking', text: 'Checking' },
          { value: 'Editing', text: 'Editing' },
          { value: 'SO Creating', text: 'SO Creating' },
          { value: 'SO Created', text: 'SO Created' },
          { value: 'DO Processing', text: 'DO Processing' },
          { value: 'DO Created', text: 'DO Created' },
          { value: 'DO completed', text: 'DO completed' },
          { value: 'Canceled', text: 'Canceled' },
          { value: 'PO Fail', text: 'Pending' }
        ],
      }
    },
    beforeDestroy() {
      this.clearPollingInterval();
    },
    mounted() {
      const stockCheckModalKey = "kioskWarehouseStockCheckModal";
      const toastMsg = sessionStorage.getItem(stockCheckModalKey);
      const toastMessageError = sessionStorage.getItem("toastMessageError");
      if (toastMsg) {
        try {
          const parsed = JSON.parse(toastMsg);
          const isFreshPayload =
            parsed &&
            parsed.source === 'kiosk-warehouse-submit-po' &&
            typeof parsed.poNumber === 'string' &&
            parsed.poNumber.length > 0 &&
            (!parsed.ts || (Date.now() - parsed.ts) < 5 * 60 * 1000);

          if (isFreshPayload) {
            this.modalInfoMessage = parsed.poNumber;
            this.modalCounterName = parsed.counterName || 'the counter';
            this.modalInfo = true
          } else {
            sessionStorage.removeItem(stockCheckModalKey);
          }
        } catch (e) {
          // Corrupted/legacy payload should not trigger modal
          sessionStorage.removeItem(stockCheckModalKey);
        }
      } else {
        // One-time cleanup: old generic key may contain unrelated messages.
        sessionStorage.removeItem("toastMessage");
      }
      
      if (toastMessageError) {
        this.$bvToast.toast(toastMsg, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        sessionStorage.removeItem("toastMessageError"); // agar tidak muncul lagi saat reload
      }

      this.$store.dispatch("dealer/getCurrentDealer"); 
      this.$store
        .dispatch('auth/fetchUser')
        .catch(err => console.log(err))
      
      this.fetchLatest()
      this.loopGetLatest()
      
    },
    computed: {
      ...mapGetters({
        purchase: 'purchase/purchase',
      }),
      mappedPurchase(){
        return this.purchase.map(item => {
          return {
            ...item,
            rspOrderNumber: item.PONumber.includes('*') ? item.PONumber.substring(0, 13) : item.PONumber,
            customerPo: item.PONumber.includes('*') ? item.PONumber.substring(14) : "",
            item: item.items.map(x => x.model),
            qty: item.items.map(x => x.updatedQty? x.updatedQty : (x.updatedReplacementQty? x.updatedReplacementQty : x.qty)),
            status : item.items.map(x => x.status ? x.status : "Not Checked Yet")
          }
        })
      },
      filteredPurchase() {
        return this.mappedPurchase.filter(item => {
          const itemDate = item.updatedAt
            ? new Date(item.updatedAt).toLocaleDateString('en-CA', { timeZone: 'Asia/Singapore' })
            : null;
          const passDate = !this.filterDate || itemDate === this.filterDate;
          return passDate;
        });
      },
      isSuperAdmin() {
        return !!(this.user && this.user.roleRef && this.user.roleRef.name === 'Super Admin');
      },
      currentDealer() {
        var tempDealer = this.$store.getters["dealer/getCurrentDealers"]
        
        if(tempDealer === null || tempDealer === undefined){
          tempDealer = {
            status : "Not Allowed"
          }
        }else{
          tempDealer = {
            status : "Allowed"
          }
        }
        return tempDealer
      },
      user() {
        return this.$store.getters['auth/getActiveUser'];
      },
      permission() {
        //console.log(userAccess("Order", "order_menu"));
        
        return userAccess("Kiosk Warehouse", "kioskWarehouse_menu");
      },
      checkPermissionAdd(){
        let tempPermission = false
        //console.log('currentDealer',this.currentDealer);
        if (this.currentDealer.status!=='Not Allowed' && this.permission.add){
          tempPermission = true
        }
  
        if(this.user.roleRef){
          if(this.user.roleRef.name==="Super Admin"||this.permission.add){
            tempPermission = true
          }
          
          
        }
        return tempPermission
      }
    },
    methods: {
        ...mapActions({
        getPurchase: 'purchase/getPurchase',
        editStatusPO: 'purchase/editStatusKioskPo',
        claimCheckStockKioskPO: 'purchase/claimCheckStockKioskPO',
        releaseCheckStockKioskPO: 'purchase/releaseCheckStockKioskPO',
      }),
      handleInfoClose() {
        this.modalInfo = false;
        sessionStorage.removeItem("kioskWarehouseStockCheckModal"); // agar tidak muncul lagi saat reload
      },
      statusParser(item){
        var orderStatus = item.orderStatus;
  
        if(orderStatus === 'Draft'){
          return 'Draft'
        }else if(orderStatus === 'PO Fail'){
          return 'Admin Review'
        }
  
        var status = item.orderStatus;
        switch(status) {
          case '':
            return 'Created'
          default:
            return `${status}`
        }
      },
      buildPurchaseParams(custom = {}) {
        return {
          search: (this.search!="") ? this.search : undefined,
          page: this.currentPage,
          entry: this.perPage,
          orderStatus: this.sapStatus,
          allAccess: this.permission.all,
          kioskFlag: true,
          updatedAt: this.filterDate || undefined,
          checkStockStatus: this.checkStockStatus && this.checkStockStatus !== 'ALL'
            ? this.checkStockStatus
            : undefined,
          ...custom
        };
      },
      onDateFilterChange() {
        this.currentPage = 1;
        this.getPurchase(this.buildPurchaseParams())
          .then((data) => this.processMetadata(data.metadata));
      },
      onCheckStockStatusChange() {
        this.currentPage = 1;
        this.getPurchase(this.buildPurchaseParams())
          .then((data) => this.processMetadata(data.metadata));
      },
      showCheckStock(item) {
        return item.orderStatus == 'Checking' && !item.status.every(status => status === 'Safe');
      },
      isClaimedByOther(item) {
        const holder = String((item && item.checkedByEmail) || '').trim().toLowerCase();
        if (!holder) {
          return false;
        }
        const me = String((this.user && this.user.email) || '').trim().toLowerCase();
        return holder !== me;
      },
      refresfMethod() {
        this.isLoading = true;
        this.getPurchase(this.buildPurchaseParams())
        .then((data) => {
          this.processMetadata(data.metadata);
          this.isLoading = false;
        });
      },
      async fetchLatest(){
        try {
          await this.getPurchase(this.buildPurchaseParams())
          .then((data) => this.processMetadata(data.metadata));
        } catch (err) {
          console.error(err);
        }
      },
      loopGetLatest(){
        if(this.isPolling || this.intervalId) return;
        this.isPolling = true;
        this.intervalId = setInterval(async () => {
          await this.fetchLatest();
        }, 10000);
      },
      clearPollingInterval() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.isPolling = false;
        }
      },
      doFiltering: lodash.debounce(function(value) {
        this.search = value;
        this.currentPage = 1;
        this.getPurchase(this.buildPurchaseParams()).then((data) => this.processMetadata(data.metadata));
      }, 500),
      statusFiltering: lodash.debounce(function(value) {
        this.sapStatus = value;
        this.currentPage = 1;
        this.getPurchase(this.buildPurchaseParams()).then((data) => this.processMetadata(data.metadata));
      }, 500),
      dates(date) {
        //console.info(date);
        return dateFormat(date);
      },
      onPageChange(page) {
        this.currentPage=page;
        this.getPurchase(this.buildPurchaseParams()).then((data) => this.processMetadata(data.metadata));
      },
      processMetadata(metadata) {
        let { totalData } = metadata;
        this.totalRows = totalData;
        this.tableLoading = false;
      },
      deleteDraft(row){
        this.modalDelete = true;
        this.selectPO = row;
        // console.log(this.selectPO);
      },
      confirmRelease(row) {
        this.modalConfirmation = true
        this.modalTitle = "Release stock check"
        this.messageModal = "release the stock check on"
        this.selectPO = row.item
      },
      confirmEdit() {
        this.modalConfirmation = false
        if (this.messageModal == "release the stock check on") {
          this.releaseCheckStockKioskPO(this.selectPO._id)
            .then(() => {
              this.getPurchase(this.buildPurchaseParams())
                .then((data) => this.processMetadata(data.metadata));
              this.$bvToast.toast("Stock check released", {
                title: "Success",
                variant: "success",
                solid: true,
              });
            })
            .catch(() => {
              this.$bvToast.toast("Release stock check failed", {
                title: "Failed",
                variant: "danger",
                solid: true,
              });
            });
          return;
        }
        let statusChange = ''
        if (this.messageModal == "Cancel") {
          statusChange = "Cancelled"
        }else if(this.messageModal == "Change status to need edit"){
          statusChange = "Need Edit"
        }else if(this.messageModal == "Change status to awaiting acknowledgement"){
          statusChange = "Awaiting Acknowledgement"
        }
        let payloadData = { status : statusChange}
        this.editStatusPO({ id : this.selectPO._id, data : payloadData})
        .then(async (response) => {
          this.getPurchase(this.buildPurchaseParams())
          .then((data) => this.processMetadata(data.metadata));

          this.$bvToast.toast(`Edit Status Kiosk Purchase Order to ${statusChange} Successfully`, {
            title: "Success",
            variant: "success",
            solid: true,
          });
        })
        .catch(async (e) => {
          console.log(e);
          this.$bvToast.toast("Edit status Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
        });
      },
      detailPO(row) {
        if (this.isClaimedByOther(row.item)) {
          return;
        }
        this.clearPollingInterval();
        const idOrder = row.item._id;
        this.claimCheckStockKioskPO(idOrder)
          .then(() => {
            this.$router.push({ name: 'kiosk-warehouse-detail', params: { id: idOrder } });
          })
          .catch((err) => {
            this.loopGetLatest();
            const status = err && err.response && err.response.status;
            const data = (err && err.response && err.response.data) || {};
            if (status === 409) {
              const poNumber = row.item.rspOrderNumber || row.item.PONumber;
              const name = data.checkedBy || 'another user';
              this.lockMessage = `PO ${poNumber} is currently being checked by ${name}`;
              this.modalLock = true;
              this.getPurchase(this.buildPurchaseParams())
                .then((result) => this.processMetadata(result.metadata));
              return;
            }
            this.$bvToast.toast("Could not start the stock check", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          });
      },
      cancelOrder(row) {
        this.modalConfirmation = true
        this.modalTitle = "Cancel Kiosk PO"
        this.messageModal = "Cancel"
        this.selectPO = row.item
      },
      needEditOrder(row) {
        this.modalConfirmation = true
        this.modalTitle = "Change to Need Edit"
        this.messageModal = "Change status to need edit"
        this.selectPO = row.item
      },
      awaitingAcknowledgement(row) {
        this.modalConfirmation = true
        this.modalTitle = "Change to Awaiting Acknowledgement"
        this.messageModal = "Change status to awaiting acknowledgement"
        this.selectPO = row.item
      },
      editDraft(row) {
        this.$router.push(`/order/draft/edit/${row.item._id}`);
      },
    },
    created() {
      document.title = 'Kiosk PO | RSP';

      this.getPurchase(this.buildPurchaseParams())
      .then((data) => this.processMetadata(data.metadata));
    },
  }
  </script>
  <style lang="scss">
    .custom-row-height {
      min-height: 120px; /* Adjust this value as needed */
    }
    .compact-header {
      th {
        padding: 0.4rem 0.3rem !important;
        font-size: 0.7rem !important; /* Added !important */
      }
    }
    
    /* Increase specificity by targeting the table element */
    .b-table.table thead.compact-header th {
      font-size: 0.7rem !important;
      padding: 0.4rem 0.3rem !important;
    }
    
    .compact-body {
      td {
        padding: 0.3rem !important;
        font-size: 0.9rem;
      }
    }

    .dropdown-show{
      overflow-y: auto;
      height: 100px;
    }
  </style>
  